import Template from "../../../components/template";
import DocumentsTypeTabs from "./components/DocumentsTypeTabs";

const ExpiredDocuments = () => {
    return (
        <Template>
            <div className="container-fluid mt-2">
                <div className="row align-items-start flex-column mb-3">
                    <div className="col-lg-5 ms-3 col-sm-8">
                        <h3 className="mb-0 h4 font-weight-bolder">Expired documents management</h3>
                    </div>
                </div>
                <DocumentsTypeTabs/>
            </div>
        </Template>
    );
};

export default ExpiredDocuments;